import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  viewContainer: {
    display: "flex",
    // position: "absolute",
    right: "0%",
    // padding: "20px",
    // Apply marginTop via inline style
  },
  icon: {
    cursor: "pointer",
  },
}));

const MapViewIcon = ({ handleMapViewClick, fill, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="30"
    viewBox="0 0 41 30"
    fill="none"
    onClick={handleMapViewClick}
    className={useStyles().icon}
  >
    <path
      d="M40.5 1V0.5H40H9C4.30558 0.5 0.5 4.30558 0.5 9V21C0.5 25.6944 4.30558 29.5 9 29.5H40H40.5V29V1Z"
      fill={fill}
    />
    <path
      d="M40.5 1V0.5H40H9C4.30558 0.5 0.5 4.30558 0.5 9V21C0.5 25.6944 4.30558 29.5 9 29.5H40H40.5V29V1Z"
      stroke="#E6E7E8"
    />
    <path
      d="M26.3079 13.9231V13.4416C26.3079 12.248 26.3079 11.6512 25.9474 11.2803C25.5869 10.9095 25.0067 10.9095 23.8463 10.9095H22.5671C22.0026 10.9095 21.9979 10.9084 21.4903 10.6544L19.44 9.6284C18.584 9.20003 18.1559 8.98584 17.7 9.00073C17.244 9.01561 16.8301 9.25729 16.0022 9.74063L15.2465 10.1818C14.6384 10.5368 14.3343 10.7143 14.1672 11.0097C14 11.305 14 11.6646 14 12.3839V17.4406C14 18.3856 14 18.8582 14.2106 19.1212C14.3508 19.2962 14.5472 19.4138 14.7643 19.4528C15.0906 19.5114 15.4902 19.2782 16.2892 18.8117C16.8318 18.4949 17.354 18.1659 18.0031 18.2551C18.547 18.3299 19.0524 18.673 19.5385 18.9163"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6875 9L17.6875 18.2309"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M22 10.8467V13.3083"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5349 14.8457C25.0336 14.8457 26.3042 16.0866 26.3042 17.5921C26.3042 19.1216 25.0129 20.1949 23.8201 20.9248C23.7332 20.9738 23.6349 20.9996 23.5349 20.9996C23.4349 20.9996 23.3366 20.9738 23.2497 20.9248C22.0591 20.1878 20.7656 19.1269 20.7656 17.5921C20.7656 16.0866 22.0362 14.8457 23.5349 14.8457Z"
      stroke={stroke}
      strokeWidth="1.5"
    />
    <path
      d="M23.5313 17.6152H23.5368"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GraphViewIcon = ({ handleGraphViewClick, fill, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="30"
    viewBox="0 0 41 30"
    fill="none"
    onClick={handleGraphViewClick}
    className={useStyles().icon}
  >
    <path
      d="M1 0.5H0.5V1V29V29.5H1H32C36.6944 29.5 40.5 25.6944 40.5 21V9C40.5 4.30558 36.6944 0.5 32 0.5H1Z"
      fill={fill}
    />
    <path
      d="M1 0.5H0.5V1V29V29.5H1H32C36.6944 29.5 40.5 25.6944 40.5 21V9C40.5 4.30558 36.6944 0.5 32 0.5H1Z"
      stroke="#E6E7E8"
    />
    <path
      d="M26.9993 20.9993H19.6664C17.4666 20.9993 16.3668 20.9993 15.6834 20.3159C15 19.6325 15 18.5326 15 16.3329V9"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M21.6641 13.667L21.6641 20.9999"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 15.666L25 20.999"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3359 15.666L18.3359 20.3324"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9993 12.3232C25.7726 12.3232 24.4609 12.4936 23.5842 11.3276C22.5861 10.0002 20.7465 10.0002 19.7483 11.3276C18.8716 12.4936 17.5599 12.3232 16.3333 12.3232H15"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const View = ({ viewValue, handleChange, tab }) => {
  const [marginTop, setMarginTop] = useState("0px");
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 1400 && tab === "SNO" && viewValue === "Graph View") {
        setMarginTop("50px");
      } else {
        setMarginTop("0px");
        console.log(marginTop);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [tab, viewValue]);

  const classes = useStyles();

  const handleViewChange = (value) => {
    handleChange(value);
  };

  return (
    <div className={classes.viewContainer}>
      <div>
        <MapViewIcon
          handleMapViewClick={() => handleViewChange("Map View")}
          fill={viewValue === "Map View" ? "#0067A1" : "#fff"}
          stroke={viewValue === "Graph View" ? "#0067A1" : "#fff"}
        />
      </div>
      <div>
        <GraphViewIcon
          handleGraphViewClick={() => handleViewChange("Graph View")}
          fill={viewValue === "Graph View" ? "#0067A1" : "#fff"}
          stroke={viewValue === "Map View" ? "#0067A1" : "#fff"}
        />
      </div>
    </div>
  );
};

export default View;
